import React from "react";
import PropTypes from "prop-types";
import cuid from 'cuid';
import { css } from "react-emotion";

const propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired
  }),
  form: PropTypes.shape({
    touched: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
  }),
  label: PropTypes.string,
  hideError: PropTypes.bool
};

class CustomInput extends React.Component {
  constructor() {
    super();
    this.id = cuid();
  }
  render() {
    const {
      field, // { name, value, onChange, onBlur }
      form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
      label,
      hideError,
      ...rest
    } = this.props;

    const invalid = touched[field.name] && errors[field.name];

    return (
      <div>
        <label htmlFor={this.id}>
          <div className="checkbox-option-wrapper">
            <span className="checkbox-icon-wrapper">
              <input id={this.id} type="checkbox" {...field} {...rest} checked={field.value} />
              <span className={`checkbox ${field.value ? "checked" : "unchecked"}`} />
            </span>
            <span className="option-label option-checked">
              {label}
            </span>
          </div>
        </label>
        {hideError !== true && (
          <div className={errorClass}>{invalid && errors[field.name]}</div>
        )}
      </div>
    );
  }
}

CustomInput.propTypes = propTypes;
export default CustomInput;

const errorClass = css`
  font-size: 12px;
  font-weight: 600;
  color: #fc3666;
  margin-left: 10px;
  margin-top: 0;
  margin-bottom: 3px;
  min-height: 31px;
`;



// WEBPACK FOOTER //
// ./src/components/form/CustomCheckbox.jsx